"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _parts = require("./parts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutocompleteWrapperModel = function () {
    function AutocompleteWrapperModel(updateCallback, getAutocompleterComponent, updateQuery, room) {
        (0, _classCallCheck3.default)(this, AutocompleteWrapperModel);

        this._updateCallback = updateCallback;
        this._getAutocompleterComponent = getAutocompleterComponent;
        this._updateQuery = updateQuery;
        this._query = null;
        this._room = room;
    }

    (0, _createClass3.default)(AutocompleteWrapperModel, [{
        key: "onEscape",
        value: function onEscape(e) {
            this._getAutocompleterComponent().onEscape(e);
            this._updateCallback({
                replacePart: new _parts.PlainPart(this._queryPart.text),
                caretOffset: this._queryOffset,
                close: true
            });
        }
    }, {
        key: "onEnter",
        value: function onEnter() {
            this._updateCallback({ close: true });
        }
    }, {
        key: "onTab",
        value: function onTab() {
            //forceCompletion here?
        }
    }, {
        key: "onUpArrow",
        value: function onUpArrow() {
            this._getAutocompleterComponent().onUpArrow();
        }
    }, {
        key: "onDownArrow",
        value: function onDownArrow() {
            this._getAutocompleterComponent().onDownArrow();
        }
    }, {
        key: "onPartUpdate",
        value: function onPartUpdate(part, offset) {
            // cache the typed value and caret here
            // so we can restore it in onComponentSelectionChange when the value is undefined (meaning it should be the typed text)
            this._queryPart = part;
            this._queryOffset = offset;
            this._updateQuery(part.text);
        }
    }, {
        key: "onComponentSelectionChange",
        value: function onComponentSelectionChange(completion) {
            if (!completion) {
                this._updateCallback({
                    replacePart: this._queryPart,
                    caretOffset: this._queryOffset
                });
            } else {
                this._updateCallback({
                    replacePart: this._partForCompletion(completion)
                });
            }
        }
    }, {
        key: "onComponentConfirm",
        value: function onComponentConfirm(completion) {
            this._updateCallback({
                replacePart: this._partForCompletion(completion),
                close: true
            });
        }
    }, {
        key: "_partForCompletion",
        value: function _partForCompletion(completion) {
            var firstChr = completion.completionId && completion.completionId[0];
            switch (firstChr) {
                case "@":
                    {
                        var displayName = completion.completion;
                        var userId = completion.completionId;
                        var member = this._room.getMember(userId);
                        return new _parts.UserPillPart(userId, displayName, member);
                    }
                case "#":
                    {
                        var displayAlias = completion.completionId;
                        return new _parts.RoomPillPart(displayAlias);
                    }
                // also used for emoji completion
                default:
                    return new _parts.PlainPart(completion.completion);
            }
        }
    }]);
    return AutocompleteWrapperModel;
}(); /*
     Copyright 2019 New Vector Ltd
     Copyright 2019 The Matrix.org Foundation C.I.C.
     
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     
         http://www.apache.org/licenses/LICENSE-2.0
     
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

exports.default = AutocompleteWrapperModel;
module.exports = exports["default"];
//# sourceMappingURL=autocomplete.js.map